import React from 'react'
import Link from 'gatsby-link'

const Chip = ({ imageUrl, title, description, to }) => (
  <div className="chip">
    <Link to={to}>
      <img src={imageUrl} className="chip__image" />
      <div className="chip__content">
        <h3 className="chip__title">{title}</h3>
        <p className="chip__description">{description}</p>
      </div>
    </Link>
  </div>
)

export default Chip



// WEBPACK FOOTER //
// ./src/components/Chip/index.js